export enum ApiEnum {
    WS_IT,
    WS_MM,
    WS_PS,
    WS_HCM,
    WS_CT,
    WS_PP,
    WS_SD
}